export const CreatedTemplateErrorMessage =
	'A template with this name has already been created.';
